import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Grow Your Business with TekRevol - A Leading React Native App
              Development Company in UK
            </h2>
            <p>
              As an award-winning React Native app development company in
              London, we help you in growing your digital presence. With the
              latest tech stack and innovative solutions, we build React Native
              apps that are compatible and operate on multiple devices giving a
              native-like performance.
            </p>
            <p>
              Our React Native app developers work collaboratively with you to
              understand the unique requirements of your business. We then
              customize our app development process to deliver solutions that
              meet the changing needs of your business & guarantee long-term
              success.
            </p>
            <p>
              TekRevol is your partner in creating the React Native app by using
              the digital tools you need to remain competitive in the UK market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../../images/location_new/fold11/Uk.webp"
                alt="Android-app-development-companies-london"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
